import { FaShieldAlt, FaLeaf, FaHistory} from 'react-icons/fa';

export const whyChooseUs = {
    sub: "whyChooseUs.sub",
    heading: "whyChooseUs.heading",
    description: "whyChooseUs.description",
    points: [
        {
            id: 1,
            title: 'whyChooseUs.points.0.title',
            content: 'whyChooseUs.points.0.content',
        },
        {
            id: 2,
            title: 'whyChooseUs.points.1.title',
            content: 'whyChooseUs.points.1.content',
        },
        {
            id: 3,
            title: 'whyChooseUs.points.2.title',
            content: 'whyChooseUs.points.2.content',
        },
    ],
};

export default whyChooseUs;